import {List} from "immutable";

export default {
  SET_VESSEL_ID: (state, vesselId) => {
    state.vessel_id = vesselId;
  },
  SET_CAMERA_LIST: (state, cameraList) => {
    state.camera_list = cameraList;
  },
  SET_VOYAGE_DATA: (state, data) => {
    state.current_time = data.current_time;
    state.start_time = data.start_time;
    state.end_time = data.end_time;
  },
  SET_MY_POINTS: (state, points) => {
    state.my_points = points;
  },
  CLEAR_MY_POINTS: (state) => {
    state.my_points = [];
  },
  MERGE_AREA_POINTS: (state, points) => {
    state.area_points = Object.freeze(state.area_points.concat(points));
  },
  MERGE_AREA_VESSELS: (state, vessels) => {
    state.area_vessels = Object.assign(state.area_vessels, vessels);
  },
  CLEAR_AREA_INFOS: (state) => {
    state.area_points = List()
  },
  CLEAR: (state) => {
    state.vessel_id = null
    state.my_points = []
    state.area_points = List()
    state.area_vessels = {}

    state.camera_list = []

    state.current_time = null
    state.start_time = null
    state.end_time = null
    state.is_pause = true
    state.fps = 1
    state.buffered_percent = 0
    state.buffer_start_time = 0
    state.buffered_map = {}

    state.is_waiting_buffered = false;

  },
  SET_CURRENT_TIME: (state, time) => {
    state.current_time = time;
  },
  SET_CURRENT_POS: (state, currentPos) => {
    state.current_pos = currentPos;
  },
  SET_PAUSE: (state, isPause) => {
    state.is_pause = isPause;
  },
  SET_FPS: (state, fps) => {
    state.fps = fps;
  },
  SET_MY_WAKES: (state, wakes) => {
    state.my_wakes = wakes;
  },
  SET_BUFFERED_PERCENT: (state, bufferedPercent) => {
    if (bufferedPercent >= 0 && bufferedPercent <= 100) {
      state.buffered_percent = bufferedPercent;
    }
  },
  SET_BUFFER_START_TIME: (state, bufferStartTime) => {
    state.buffer_start_time = bufferStartTime;
  },
  ADD_BUFFERED_MAP: (state, bufferedSecond) => {
    state.buffered_map[bufferedSecond] = true;
  },
  SET_IS_WAITING_BUFFERED: (state, isWaitingBuffered) => {
    state.is_waiting_buffered = isWaitingBuffered;
  },
  RESET_STATE(state, data) {
    Object.assign(state, data)
  },
  SET_MY_VESSELS: (state, points) => {
    state.myVessel = points;
  },
  SET_MY_VESSEL_ID: (state, data) => {
    state.myVesselId = data;
  },
  SET_VESSEL_MAP_OBJECTS: (state, data) => {
    state.vesselMapObjects = data;
  },
  SET_MY_TRACKS: (state, data) => {
    state.myTracks = data;
  },
  SET_PLAY_BUCK_TIME_RANGE: (state, payload) => {
    state.start_time = payload.startTime;
    state.end_time = payload.endTime;
  },
  SET_CHUNK_POINTS: (state, data) => {
    state.chunkPoints = data;
  },
  SET_START_POINT_GEO_JSON: (state, data) => {
    state.startPointGeoJson = data;
  },


};
